var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_vm._v(_vm._s(_vm.moduleName || "Unknown"))]),_vm._l((_vm.groupedTrips.trips),function(trip,index){return _c('StoredTripCard',{key:`stored-trip-card-${index}`,attrs:{"tripDetail":trip}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }